import { SupportMessage } from '../../interfaces/support-message';
import { ApiPostRequest } from './api-post-request';

export class SupportMessageRequest extends ApiPostRequest
{
    public constructor(messageObject: SupportMessage, webapiBasepath: string)
    {
        super('customer-care/cases', null, null, messageObject, webapiBasepath);
    }
}
